import { IApp } from "../../../../../../App/Typings/AbacApp";
import { ITableColumn } from "../../../../../../App/Typings/Table";
import { useGetAllFeaturesForAbacAppQuery } from "../../../../AbacAppQueries";
import useCreateFeatureFormState from "./CreateFeatureFormState";
// import { useGetAbacAppsQuery } from "../../AbacAppQueries";
// import useCreateAppFormState from "./CreateAppFormState";

export default function useAbacFeaturesState(app: IApp) {
  const createFeatureModalTitle = "Create New Feature";
  const { data: features = [], isLoading: isFeatureListLoading } =
    useGetAllFeaturesForAbacAppQuery(app.id);
  const {
    getters: { createIsLoading, formik },
    handlers: { handleCreateModalClose },
  } = useCreateFeatureFormState(app.id);

  const columns: ITableColumn[] = [
    { label: "Feature Name", propName: "name" },
    { label: "Feature Key", propName: "key" },
    { label: "Last Updated", propName: "updatedDate" },
    { label: "Require All Attributes", propName: "requireAll" },
    { label: "Is Active", propName: "isActive" },
  ];

  return {
    getters: {
      features,
      columns,
      isFeatureListLoading,
      createFeatureModalTitle,
      createIsLoading,
      formik,
    },
    handlers: {
      handleCreateModalClose,
    },
  };
}
